/* eslint-disable react/prop-types */
import React from 'react'
import { Field } from 'redux-form'
import cx from 'classnames'

import ReduxFormDropdown from '@cred/react-basic-form-fields/reduxForm/Dropdown'

import styles from './styles.module.scss'

const DropdownRedux = (props) => {
  const { options, children, className, ...rest } = props
  return (
    <Field component={ReduxFormDropdown} className={cx(styles.dropdownRedux, className)} {...rest}>
      {options
        ? options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))
        : children}
    </Field>
  )
}

export default DropdownRedux
